<template>
  <v-dialog :value="value" persistent max-width="750" @click:outside="closeDialog()">
    <v-card color="fill">
      <v-container class="shipperCon">
        <v-card-title class="my-0 py-0 pt-0 heading-6">
          <v-row justify="space-between" class="my-2">
            <v-col class="ma-0 pa-0 pb-4" align="start">
              <div class="text-no-wrap">
                Select Export Details
              </div>
            </v-col>
            <v-col class="pa-0 ma-0 pr-4" align="end">
              <v-btn icon @click="closeDialog()">
                <v-icon dense>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <template v-if="isJbg">
          <v-row no-gutters align="center" class="mb-2">
            <v-col cols="5">
              <v-select
                v-model="selectedTemplateId"
                :items="templates"
                item-text="name"
                item-value="template_id"
                label="Apply a saved template"
                dense
                outlined
                hide-details
                clearable
                :loading="loadingTemplates"
                @change="loadTemplate">
              </v-select>
            </v-col>
            <v-col v-if="templateError" cols="12" class="pt-1">
              <span class="error--text caption">{{ templateError }}</span>
            </v-col>
          </v-row>
          <v-divider class="mb-4"></v-divider>
        </template>

        <v-row no-gutters>
          <v-col
            v-for="(detail, index) in detailSelectionList"
            :key="index"
            cols="3">
            <v-checkbox
              v-model="details"
              :value="detail"
              :label="detail.label"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row justify="end" class="mb-2 mr-2">
          <v-btn
            color="primary"
            :disabled="details.length === 0"
            @click="exportItems">
            Export
            <v-icon class="pl-2 pt-0" size="large">
              mdi-download
            </v-icon>
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Items from '@/api/endpoints'
import { buildExportColumns } from '@/components/items/data/exportColumns'

export default {
  name: 'ExportDetailsModal',
  props: {
    value: Boolean,
    isRetailer: Boolean,
    selectedItemDetails: Array,
    searchParams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      details: [],
      templates: [],
      selectedTemplateId: null,
      templateError: '',
      loadingTemplates: false
    }
  },
  async mounted() {
    if (this.selectedItemDetails && this.selectedItemDetails.length > 0) {
      this.details = this.selectedItemDetails
    }
    if (this.isJbg) {
      await this.fetchTemplates()
    }
  },
  watch: {
    details() {
      this.$emit('update:selectedItemDetails', this.details)
      localStorage.setItem('selectedItemDetails', JSON.stringify(this.details))
    }
  },
  computed: {
    isJbg () {
      return this.$auth.tenant === 'jbg'
    },
    detailSelectionList () {
      return buildExportColumns(this.$auth.tenant, this.isRetailer)
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    exportItems() {
      this.$emit('exportItems')
    },
    async fetchTemplates() {
      this.loadingTemplates = true
      try {
        const res = await Items.getExportTemplates()
        this.templates = (res && res.items) ? res.items : []
      } catch (err) {
        this.templateError = 'Unable to load saved templates.'
      } finally {
        this.loadingTemplates = false
      }
    },
    loadTemplate(templateId) {
      this.templateError = ''
      const template = this.templates.find(t => t.template_id === templateId)
      if (!template) {
        // Selection cleared: fall back to the current search for the export.
        this.$emit('loadTemplate', null)
        return
      }
      const config = template.config || {}
      const fieldIds = config.fields || []
      this.details = this.detailSelectionList.filter(d => fieldIds.includes(d.id))
      this.$emit('loadTemplate', config.filters || {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ExportDetailsModal.vue